import script from "./RegisterConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterConfirmModal.vue?vue&type=style&index=0&id=5ff9ad30&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff9ad30"]])

export default __exports__